import { render, staticRenderFns } from "./DetailsAmountAndFee.vue?vue&type=template&id=12933af6&scoped=true"
import script from "./DetailsAmountAndFee.vue?vue&type=script&lang=js"
export * from "./DetailsAmountAndFee.vue?vue&type=script&lang=js"
import style0 from "./DetailsAmountAndFee.vue?vue&type=style&index=0&id=12933af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12933af6",
  null
  
)

export default component.exports